/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsWorkloadType from '@jira/spa-apps__servicedesk-reports-workload/src/ReportsIssueViewSpa.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { WORKLOAD_ROUTE_SUFFIX } from '../../common/constants.tsx';

export const LazyServicedeskReportsWorkload: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskReportsWorkloadType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-workload", jiraSpaEntry: "async-servicedesk-reports-workload" */ '@jira/spa-apps__servicedesk-reports-workload/src/ReportsIssueViewSpa.tsx'
		),
	),
);

const AsyncServicedeskReportsWorkload = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskReportsWorkload}
		pageId={`spa-apps/servicedesk${WORKLOAD_ROUTE_SUFFIX}}`}
		shouldShowSpinner
	/>
);

export default AsyncServicedeskReportsWorkload;
